<script>
import RepCounter from '@components/counters/rep-counter.vue';
import RestCounter from '@components/counters/rest-counter.vue';
import TimeCounter from '@components/counters/time-counter.vue';
import WeightCounter from '@components/counters/weight-counter.vue';

export default {
  components: {
    RepCounter,
    RestCounter,
    TimeCounter,
    WeightCounter,
  },
  props: {
    setDirections: {
      type: Object,
      required: true,
      default: () => {},
    },
    exerciseSetIndex: {
      type: Number,
      required: true,
      default: null,
    },
    allowEditing: {
      type: Boolean,
      required: true,
      default: false,
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    onAdjustReps(count) {
      this.$emit('adjust-reps', { count, index: this.exerciseSetIndex });
    },
    onAdjustTime(count) {
      this.$emit('adjust-time', { count, index: this.exerciseSetIndex });
    },
    onAdjustWeight(count) {
      this.$emit('adjust-weight', { count, index: this.exerciseSetIndex });
    },
    onAdjustRest(count) {
      this.$emit('adjust-rest', { count, index: this.exerciseSetIndex });
    },
  },
};
</script>

<template>
  <div class="exercise-set-detail-counters">
    <div class="row">
      <div class="col">
        <RepCounter
          :key="setDirections.reps"
          :count="setDirections.reps"
          :minimal="true"
          :startNum="0"
          @adjust-reps="onAdjustReps"
          :allowEditing="allowEditing"
        />
      </div>
      <div class="col">
        <TimeCounter
          :key="setDirections.time"
          :count="setDirections.time"
          @adjust-time="onAdjustTime"
          :allowEditing="allowEditing"
        />
      </div>
      <div class="col">
        <WeightCounter
          :key="setDirections.weight"
          :count="setDirections.weight"
          @adjust-weight="onAdjustWeight"
          :allowEditing="allowEditing"
        />
      </div>
      <div class="col">
        <RestCounter
          :key="setDirections.afterSetRest"
          :count="setDirections.afterSetRest"
          @adjust-rest="onAdjustRest"
          :allowEditing="allowEditing"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.exercise-set-detail-counters {
  padding: 1.6rem 0;

  &:not(:first-of-type) {
    border-top: 1px solid $color-light-gray;
  }
}
</style>
